
<template>

  <div class="boxWrapper d-flex flex-column rounded"
    :style="{ visibility: showFaq ? 'visible' : 'hidden' }">



    <template :class="toggle == 'chat' ? 'd-block' : 'd-none'" style="height: calc(100% - 45px); overflow: auto;">
      <ChatBox :checkChatState="checkChatState" :site="site" />
    </template>

      <template :class="toggle == 'faq' ? 'd-block' : 'd-none'" style="height: calc(100% - 45px);">
        <FaqBox :theme="theme" :site="site" />
      </template>



    <div class="w-100 d-flex rounded-bottom fw-bold" style=" z-index: 200; height: 45px; font-size: 12px; cursor: pointer;">
      <div class="w-50 py-1 d-flex align-items-center justify-content-center"  @click="toggle = 'faq'" :class="toggle=='faq'? 'btn-primary' : 'btn-light'">Frågor och svar</div>
      <div class="w-50 py-1 d-flex align-items-center justify-content-center" @click="toggle = 'chat'" :class="toggle=='chat'? 'btn-primary' : 'btn-light'">{{chatOnline? 'Chatta med oss': 'Kontakt'}} 
        <div v-if="chatOnline" class="rounded-circle online shadow position-absolute " style="background-color: #45E900; height: 8px; width : 8px; bottom: 25px; right: 10px;"></div>
      </div>
    </div>

  </div>


  <div class="faqToggle d-flex align-items-center" @click="showFaq = !showFaq">
    <div v-if="!showFaq" class="helpText shadow-sm py-2 px-4 fw-bold fs-6 mr-2 shadow"
      v-html="chatOnline ? 'Frågor? Chatta med oss.' : 'Behöver du hjälp?'"></div>
    <div class="toggleBtn shadow-sm rounded-circle d-flex justify-content-center align-items-center">
      <div v-if="chatOnline" class="rounded-circle online shadow"
        style="background-color: #45E900; border: 2px solid white; position: absolute; height: 12px; width :12px; top:4px; right: 4px;">
      </div><i :class="toggleIcon"></i>
    </div>
  </div>



  <ComponentStyles>
    * {
    box-sizing:border-box;
    }

    #boxSearchInput{
      border-radius: 5px;
      border: solid 1px lightgrey;
      padding: 5px;

    }

    #boxSearchInput:focus-visible {
      
      outline: none;
    }

    .faqToggle{
      
      cursor: pointer;
    z-index: 9999;
    position: fixed;
    inset: 0px 5px 0px auto;
    bottom: 5px;
    top: auto;

    }

    .faqToggle > .toggleBtn {
    height: 63px;
    width: 63px;
    {{ theme.toggleBtn }}
    }
    .faqToggle > .helpText {
    border-radius: 2rem;
    {{ theme.helpText }}
    }



    .boxWrapper {
    {{ theme.bg }}
    z-index: 9999;
    width: 368px;
    height: 449px;
    max-height: calc(100% - 182px);
    position: fixed;
    box-sizing: border-box;
    inset: 0px 16px 0px auto;
    bottom:100px;
    top: auto;
    box-shadow: -0px -0px 10px;
    }

    .iconBg {
    width: 36px;
    height: 36px;
    {{ theme.iconBg }}
    }


    .boxWrapper ::-webkit-scrollbar,
    .card-body ::-webkit-scrollbar {
      width: 0 !important;
      height: 4px !important;
    }

    .livechatBtn{
    border-radius: 2em;
    font-weight: 600;
    }

    .slide-main-leave-active,
    .slide-main-enter-active {
    transition: all 0.1s ease-in;
    }


    .slide-main-leave-to,
    .slide-main-enter-from {
    transform: translateX(200px);
    opacity: 0;
    }

    .slide-sub-enter-active {
    transition: all .3s ease-in;
    }


    .slide-sub-leave-to,
    .slide-sub-enter-from {
    transform: translateY(15px);
    opacity: 0;
    }

    @media only screen and (max-width: 400px) {
    .boxWrapper {
    width: 98%;
    inset: 0 1%;
    top: auto;
    bottom:100px;
    }
    }

    @media screen and (max-width: 576px) {
      

      .toggleBtn {
        position: absolute;
        border-radius: 0 !important;
        transform: rotate(45deg);
        height: 300px !important; 
        right: 0;
      }

      .toggleBtn i {
        position: relative;
        bottom: 22px;
        right: 5px;
        transform: rotate(-45deg);
      }

      .toggleBtn .rounded-circle {
        top: 105px !important;
        right: 32px !important;
        z-index: 90;
        border:0 !important;
      }

      .helpText {
        display: none;
      }


    }

    #boxQuestionAccordion .accordion-item{
      border-bottom: 1px solid #ddd;
    }
    
    #boxQuestionAccordion.accordion-header{
      font-size: 1em;
      margin: 0;
    }
    
    #boxQuestionAccordion .accordion-button{
        font-weight: 600;
        border: 0 !important;
        background: none;
        font-size: 1em !important;
        display: block;
        width: 100%;
        text-align: left;
        padding: 16px 0;
    }
    #boxQuestionAccordion .accordion-button:focus{
        outline: none !important;
    }
    .inside-wrapper .fa-arrow-left.fs-2 {
        color: #fff;
        font-size: 30px;
        margin-right: 10px;
    }
    #chat-card > h4.card-header > button.close {
      visibility:   hidden !important;
      font-size: 0px;
    }




  </ComponentStyles>
</template>

<script>

import ChatBox from "./ChatBox.vue";
import ComponentStyles from "../componentStyles.vue";
import FaqBox from "./FaqBox.vue";
export default {


  props: ['site'],

  data() {
    let chatOnline = false;
    let showFaq = false;
    let toggleIcon = "fa-solid fa-question-circle fs-2";
    let toggle = 'faq';

    let theme = {
      toggleBtn: "background: #47525D; color: #FFF2E3;",
      chatBtn: 'background : #47525D; color: #FFFFFF;',
      bg: " background: #F6F6F6;",
      iconBg: 'background : #FFF2E3; color: #47525D;',
      helpText: 'background: #47525D; color: #FFFFFF;',
      darkText: 'color: #47525D',

    }



    if (this.site == "gn") {
      theme = {
        toggleBtn: "background: #0C555B; color: #DA9C4F;",
        chatBtn: 'background : #0C555B ; color: #fff;',
        bg: "background: #E6EFF1;",
        iconBg: 'background: #0C555B; color: #DA9C4F;',
        helpText: 'background: #E6EFF1; color: #0C555B;',
        darkText: 'color: #0C555B'
      }
    }




    return {

      chatOnline,
      showFaq,
      toggleIcon,
      theme,
      toggle

    }


  },

  components: { ChatBox, ComponentStyles, FaqBox },

  methods: {

    
    checkChatState(status) {

      this.chatOnline = status;
      console.log(status)
      this.iconControl()
    },

    iconControl() {
      if (this.showFaq == false && this.chatOnline == false) {
        this.toggleIcon = "fa-solid fa-question-circle fs-2"
      }

      else if (this.showFaq == false && this.chatOnline == true) {
        this.toggleIcon = " fa-solid fa-message-lines fs-3"
      }

      else { this.toggleIcon = "fa-light fa-xmark fs-3" }
    },


  },



  watch: {


    showFaq() {
      this.iconControl()
    },

  },






  mounted() {
    document.addEventListener('keydown', (event) => { if(event.key === "Escape"){this.showFaq = false} })
    window.showFaqChat = function () {
      this.showFaq = true;
      this.toggle = 'chat';
      console.log("HEJ")
    }
  }

}
 
</script>
